import Vue from 'vue'
import app from './App.vue'
import router from './router'
import store from './store/index'
import resxPlugin from './plugins/MyResourcesPlugin'
import VueGtag from 'vue-gtag'
import moment from 'moment'
import VeeValidate from 'vee-validate'

import 'moment/locale/fr'
import 'moment/locale/es'
import 'moment/locale/de'
import 'moment/locale/it'
import 'moment/locale/nl'

// init moment locale
moment.locale(global.dataInit.culture.substring(0, 2))

require('./assets/main.less')
require('./assets/app.less')

// on init le camping par defaut
if (global.dataInit.defaultCamping !== null) {
  // console.log('on selectionne le camping')
  store.commit('partner/selectCampsite', global.dataInit.defaultCamping)
}

Vue.use(VeeValidate)
Vue.use(resxPlugin)
Vue.use(VueGtag, {
  config: { id: 'G-T4HEXPVNM1' }
}, router)

// on bloque le user sur la home si le camping n'est pas affecté
router.beforeEach((to, from, next) => {
  if (to.name !== 'home' && store.state.partner.account.currentCamping === null) {
    next({ name: 'home' })
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(app)
}).$mount('#app')
